import { iconButton } from "../kit/components.ts";
import type { KitIcon } from "../kit/kit-model.ts";
import { h } from "../kit/dom.ts";

/** Um botão do canto: o ícone do kit, o nome, a tecla que ele mostra e o que faz. */
export interface CornerButton {
  id: string;
  icon: KitIcon;
  label: string;
  /** Ação remapeável (o rótulo acompanha as Opções por `refreshKeyHints`) ou a tecla fixa ("Esc"). */
  key: { action: string; name: string } | { fixed: string };
  onClick: () => void;
}

/**
 * Botões do canto (F81, mockup ui-b, acima do minimapa): Opções, Mochila, Mapa e Pausa, cada um com a tecla.
 * Clicáveis com o ponteiro livre (com ele travado, o clique é do jogo). Depois do clique o botão solta o
 * foco: Enter e Espaço voltam a ser do jogo.
 */
export class CornerButtons {
  readonly element: HTMLElement;

  constructor(parent: HTMLElement, buttons: readonly CornerButton[]) {
    this.element = h(
      "nav",
      { id: "botoes-canto", "aria-label": "Atalhos" },
      ...buttons.map((b) => {
        const button = iconButton({ icon: b.icon, label: b.label });
        button.id = b.id;
        button.addEventListener("click", () => {
          button.blur();
          b.onClick();
        });
        // A tecla: `data-tecla`/`data-modelo` deixam o `refreshKeyHints` das Opções trocar o nome ao remapear.
        const key = "fixed" in b.key ? h("kbd", { class: "tecla" }, b.key.fixed) : h("kbd", { class: "tecla", "data-tecla": b.key.action, "data-modelo": "{}" }, b.key.name);
        button.appendChild(key);
        return button;
      }),
    );
    parent.appendChild(this.element);
  }

  remove(): void {
    this.element.remove();
  }
}
